
<template>
    <div v-show="show" class="login-type common-dialog">
        <div class="dialog">
            <div class="title">
                <span>請選擇登入方式</span>
                <div class="close-btn btn" @click="closeDialog"></div>
            </div>
            <div class="buttons">
                <div class="login-single" @click="loginSingle"></div>
                <div class="login-knsh" @click="loginKnsh"></div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '../../../js/event_bus';
import AppRenderer from '../../../js/app_renderer';
export default {
    name: "LoginType",
    data: function () {
        return {
            show: false
        }
    },
    methods: {
        loginKnsh: function () {
            EventBus.getInstance().getAppRefs().loginKnsh.show = true;

            this.show = false;
        },
        loginSingle: function () {
            AppRenderer.Instance.startSingleLogin();
            this.show = false;
        },
        closeDialog: function () {
            this.show = false;
        }
    }
}
</script>



<style src="../../../css/dialog_style.css" scoped />

<style scoped>
.login-type {
    display: grid;
    grid-template-columns: 1fr 480px 1fr;
    grid-template-rows: repeat(12, 1fr);
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;

    grid-auto-columns: minmax(160px, auto);
    background-color: #0000007f
}

.dialog {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 5;
    grid-row-end: 8;

    min-width: 480px;
    min-height: 254px;

    background-color: white;

    display: flex;
    flex-direction: column;
}

.title {
    height: 64px;
    background-color: #6C99FE;
    display: flex;
    color: white;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
}

.title span {
    font-size: 1.5rem;
}

.buttons {
    display: flex;
    flex-direction: row;
    height: calc(100% - 64px);
    justify-content: space-around;
    align-items: center;
}

.login-single {
    background-image: url("../../../assets/login/btn_singlie_login.png");
    background-size: contain;
    background-repeat: no-repeat;
    width: 150px;
    height: 150px;
    cursor: pointer;
}

.login-knsh {
    background-image: url("../../../assets/login/btn_knsh_login.png");
    background-size: contain;
    background-repeat: no-repeat;
    width: 150px;
    height: 150px;
    cursor: pointer;
}

.btn {
    position: absolute;
    margin-left: 420px;
}
</style>